import { schema } from 'normalizr';
import { PapiGallection } from '@wix/da-papi-types';
import { deviationSchema } from './deviation';
import { userSchema } from './user';

export const collectionFolderSchema = new schema.Entity(
  'collectionFolder',
  {
    thumb: deviationSchema,
    owner: userSchema,
  },
  {
    idAttribute: 'folderId',
  }
);
export const collectionListSchema = [collectionFolderSchema];
collectionFolderSchema.define({ subfolders: collectionListSchema });

export const galleryFolderSchema = new schema.Entity(
  'galleryFolder',
  {
    thumb: deviationSchema,
    owner: userSchema,
  },
  {
    idAttribute: 'folderId',
  }
);
export const galleryListSchema = [galleryFolderSchema];
galleryFolderSchema.define({ subfolders: galleryListSchema });

export const stashFolderSchema = new schema.Entity(
  'stashFolder',
  {
    thumb: deviationSchema,
    owner: userSchema,
  },
  {
    idAttribute: 'folderId',
  }
);
export const stashListSchema = [stashFolderSchema];
stashFolderSchema.define({ subfolders: stashListSchema });

// To allow for streams with mixed gallection types we need to use a composite
// gallection id to avoid id collissions (similar what we do with deviations)

const getGallectionCompositeId = (type: string, folderId: number) =>
  `${type}-${folderId}`;

export const getGallectionEntityId = (value: PapiGallection) =>
  getGallectionCompositeId(value.type, value.folderId) as string;

const processStrategy = (value: PapiGallection) => {
  return { ...value, entityId: getGallectionEntityId(value) };
};

export const gallectionSchema = new schema.Entity(
  'gallection',
  {
    owner: userSchema,
    groupDestination: userSchema,
  },
  {
    idAttribute: getGallectionEntityId,
    processStrategy,
  }
);
export const gallectionListSchema = [gallectionSchema];

export const getGallectionEntityIds = (values: PapiGallection[]) =>
  values.map(getGallectionEntityId);
